import Portal from "@mui/material/Portal";
import dynamic from "next/dynamic";
import { useAudioPlayerStore } from "src/stores/audio-player-store";

const AudioPlayerLazy = dynamic(() => import("src/components-mui/common/audio-player/audio-player").then(m => ({ default: m.AudioPlayer })), {
    ssr: false,
});

export const LazyAudioPlayer = () => {
    const { isLoaded } = useAudioPlayerStore();

    if (!isLoaded) {
        return null;
    }

    return (
        <Portal>
            <AudioPlayerLazy />
        </Portal>
    );
};
